<template>
    <div class="if-box " style="width: 440px;">
        <div class="edit-profile">
            <div class="profile-box">
<!--                <div class="edit-icon"><i class="iconfont iconbianji"></i></div>-->
                <el-avatar :size="98" :src="userInfo.profile">
                    <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
                </el-avatar>
            </div>
        </div>
        <div class="if-item">
            <div class="l">用户ID：</div>
            <div class="r">{{userInfo.uid}}</div>
        </div>
      <div class="if-item">
        <div class="l">账户余额：</div>
        <div class="r">{{userInfo.money}}
          <a href="/tabs/charge" class="but_charge">充值</a>
        </div>
      </div>
        <div class="if-item">
            <div class="l">用户昵称：</div>
            <div class="r">
                <span v-show="!isEditNik">{{userInfo.nickname}}</span>
                <el-link class="ml-10" v-show="!isEditNik" type="primary" @click="isEditNik=true">修改</el-link>
                <el-input class="inp" v-show="isEditNik" size="mini" placeholder="请输入新昵称" clearable v-model="newNik"></el-input>
                <el-link class="ml-10" v-show="isEditNik" type="primary" @click="saveNickname">保存</el-link>
                <el-link class="ml-10" v-show="isEditNik" type="primary" @click="isEditNik=false">取消</el-link>
            </div>
        </div>
        <div class="if-item">
            <div class="l">设置登录密码：</div>
            <div class="r">
                <span v-show="!isEditPas">*****</span>
                <el-link class="ml-10" v-show="!isEditPas" type="primary" @click="isEditPas=true">修改</el-link>
                <el-input class="inp" v-show="isEditPas" size="mini" placeholder="请输入新密码" clearable v-model="newPass"></el-input>
                <el-link class="ml-10" v-show="isEditPas" type="primary" @click="savePass">保存</el-link>
                <el-link class="ml-10" v-show="isEditPas" type="primary" @click="isEditPas=false">取消</el-link>
            </div>
        </div>
        <div class="if-item">
            <div class="l">手机号码：</div>
            <div class="r">
                <span>{{userInfo.uphone}}</span>
<!--                <el-link class="ml-10" type="primary" v-if="userInfo.uphone">修改</el-link>-->
            </div>
        </div>
      <div class="if-item">
        <div class="l">通知邮箱：</div>
        <div class="r">
          <span v-show="!isEditEmail">{{userInfo.notify_email}}</span>
          <el-link class="ml-10" v-show="!isEditEmail" type="primary" @click="isEditEmail=true">修改</el-link>
          <el-input class="inp" v-show="isEditEmail" size="mini" placeholder="请输入新邮箱" clearable v-model="newEmail"></el-input>
          <el-link class="ml-10" v-show="isEditEmail" type="primary" @click="saveEmail">保存</el-link>
          <el-link class="ml-10" v-show="isEditEmail" type="primary" @click="isEditEmail=false">取消</el-link>
        </div>
      </div>

	   <div class="if-item">
		  <div class="l"> 二维码logo：</div>
		  <div class="r">
			
			
			<el-upload
				action=""
				:http-request="upload_img"
				:show-file-list="false"
				accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF"
				:on-success="null">
				<img :src="userInfo.qr_logo+''" class="pic-50" v-if="userInfo.qr_logo" />
			  <span class="border-gray pad510 bg_gray_eee radius-5 fs12 ml10">+点击上传</span>
			  <span class="fs12 ml10">只能上传图片文件，且不超过5mb</span>
			</el-upload>
		  </div>
	  </div>


        <div class="if-item">
            <div class="l">注册时间：</div>
            <div class="r">{{userInfo.reg_time*1000 | dateFormat}}</div>
        </div>
        <div class="if-item">
            <div class="l">最近登录时间：</div>
            <div class="r">{{userInfo.last_login*1000 | dateFormat}}</div>
        </div>
        <div class="if-item">
            <div class="l">最近登录IP：</div>
            <div class="r">
                <span>{{userInfo.last_ip}}</span>
                <span v-if="userInfo.last_add">（{{userInfo.last_add}}）</span></div>
        </div>
        <div class="if-item">
            <div class="l">账户状态：</div>
            <div class="r">
                <el-tag effect="dark" v-if="userInfo.ustate==1">正常</el-tag>
                <el-tag effect="dark" v-else type="info">异常</el-tag>
            </div>
        </div>
        <div class="if-item">
            <div class="l">会员身份：</div>
            <div class="r">
                <el-tag effect="dark" type="danger" v-if="userInfo.isVip==1">VIP会员</el-tag>
                <el-tag effect="dark" v-else>普通会员</el-tag>
            </div>
        </div>
        <div class="if-item">
            <div class="l">会员到期时间：</div>
            <div class="r">{{userInfo.expire_date}}</div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Info",
        data() {
            return {
                newNik: '',
                isEditNik: false,
              isEditEmail: false,
                newPass:'',
              newEmail:'',
                isEditPas: false,
                userInfo:{},
            }
        },
        mounted() {
            setTimeout(this.getUserInfo,200);
        },
        methods: {
            async getUserInfo() {
                const {ret,data} = await this.$api.user.getUserInfo();
                if (ret === 1000){
                    this.userInfo = data;
                }
            },
            async saveNickname() {
                const name = this.newNik;
                if (name === '') return;
                const reg = /^[\u4e00-\u9fa5a-zA-Z0-9_-]{2,16}$/u;
                if (!reg.test(name)){
                    this.$alert('昵称只能是2-16位(字母、数字、下划线、横线)', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: action => {
                            console.log(action);
                        }
                    });
                    return;
                }
                const {ret} = await this.$api.user.saveNickname({name:name});
                if (ret === 1000){
                    this.newNik = '';
                    this.isEditNik = false;
                    this.userInfo.nickname = name;
                    this.$message.success("修改成功");
                }
            },
          async saveEmail() {
            const email = this.newEmail;
            if (email === '') return;
            const reg = /@/u;
            if (!reg.test(email)){
              this.$alert('请输入正确邮箱', '提示', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {
                  console.log(action);
                }
              });
              return;
            }
            const {ret} = await this.$api.user.saveEmail({email:email});
            if (ret === 1000){
              this.newEmail = '';
              this.isEditEmail = false;
              this.userInfo.notify_email = email;
              this.$message.success("修改成功");
            }
          },
		 async savePass() {
				const newPass = this.newPass;
				if (newPass === '') return;
				const reg = /^[a-zA-Z0-9_]{6,15}$/u;
				if (!reg.test(newPass)){
					this.$alert('密码只能是2-16位(字母、数字、下划线)', '提示', {
						confirmButtonText: '确定',
						type: 'error',
						callback: action => {
							console.log(action);
						}
					});
					return;
				}
				const {ret} = await this.$api.user.savePass({newpass:newPass});
				if (ret === 1000){
					this.newPass = '';
					this.isEditPas = false;
					this.$message.success("修改成功");
				}
		  },

          async upload_img(file){
            var $this=this;
            this.$common.Upload(file,function(img){
              console.log(img);
              $this.userInfo['qr_logo']=img
              $this.$forceUpdate();
			  $this.save_qrlogo(img);
			  
            });
          },
		  async save_qrlogo(img){
			  var $this=this;
			 const {ret} = await $this.$api.user.saveQrlogo({qr_logo:img});
			 if (ret === 1000){
			   this.$message.success("修改成功");
			 } 
		  }
        }
    }
</script>

<style scoped>
    .if-box{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .if-box .edit-profile{
        width: 100%;
        height: 100px;
        margin-bottom: 20px;
    }
    .if-box .edit-profile .profile-box{
        width: 98px;
        height: 98px;
        margin: 0 auto;
        border: 1px solid #C0C4CC;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
    }
    .if-box .edit-profile .profile-box .edit-icon{
        width: 98px;
        height: 98px;
        background-color: rgba(0,0,0,0.5);
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
        color: #ffffff;
        line-height: 98px;
        display: none;
        cursor: pointer;
    }
    .if-box .edit-profile .profile-box:hover .edit-icon{
        display: block;
    }
    .if-box .edit-profile .profile-box .edit-icon i{
        font-size: 32px;
    }
    .if-box .if-item{
        width: 100%;
        height: 60px;
        font-size: 20px;
        line-height: 60px;
        overflow: hidden;
    }
    .if-box .if-item .l{
        display: inline-block;
        width: 260px;
        height: 60px;
        color: #666666;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }
    .if-box .if-item .r{
        display: inline-block;
        width: 150px;
        height: 60px;
        margin-left: 10px;
        vertical-align: top;
    }
    .if-box .if-item .r .inp{
        width: 200px;
    }
    .ml-10{
        margin-left: 10px;
    }
</style>
